import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";

import {
    ShapeListOptionContainer,
    ShapeIconSquare,
    ShapeIconRounded,
    ShapeIconCircle,
    ShapeIconRing
} from "./styles";

import { SHAPES } from "./constants";

const ShapeListOption = ({
    handleShapeSelect,
    currentShape,
    optionShape,
    children
}) => {
    let Shape;

    if (optionShape === SHAPES.SQUARE) {
        Shape = ShapeIconSquare;
    }

    if (optionShape === SHAPES.ROUNDED) {
        Shape = ShapeIconRounded;
    }

    if (optionShape === SHAPES.CIRCLE) {
        Shape = ShapeIconCircle;
    }

    if (optionShape === SHAPES.RING) {
        Shape = ShapeIconRing;
    }

    const optionIsChecked = currentShape === optionShape;

    return (
        <ShapeListOptionContainer>
            <input
                value={optionShape}
                id={optionShape}
                name="shape"
                type="radio"
                onChange={handleShapeSelect}
                checked={optionIsChecked}
            />
            <label htmlFor={optionShape}>
                <BodyText size="sm">{children}</BodyText>
                <Shape />
            </label>
        </ShapeListOptionContainer>
    );
};

ShapeListOption.propTypes = {
    handleShapeSelect: PropTypes.func.isRequired,
    currentShape: PropTypes.string.isRequired,
    optionShape: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default ShapeListOption;
